import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./profileStatusDropdown.css";

const ProfileStatusDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    { value: "", label: "All" },
    { value: "basic", label: "Basic" },
    { value: "document", label: "Document" },
    { value: "interview", label: "Interview" },
    { value: "home", label: "Home" },
  ];

  const selectedOption = options.find((opt) => opt.value === value);

  const handleSelect = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };

  return (
    <div className="psd-wrapper">
      <button
        className="psd-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="psd-label">{selectedOption?.label}</span>
        <ChevronDown
          size={18}
          className={`psd-chevron ${isOpen ? "open" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="psd-menu">
          {options.map((option) => (
            <button
              key={option.value}
              className={`psd-option ${value === option.value ? "active" : ""}`}
              onClick={() => handleSelect(option.value)}
            >
              <span className="psd-option-label">{option.label}</span>
              {value === option.value && (
                <span className="psd-checkmark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProfileStatusDropdown;